import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import '../styles/Welcome.css'

/**
 * Welcome/Landing page component
 *
 * This is the new main landing page that explains the multi-page structure
 * and provides navigation to different sections of the site.
 *
 * @ai-context This is the entry point for visitors. Keep it clean and navigable.
 */
function Welcome() {
  return (
    <div className="welcome-container">
      <Helmet>
        <title>David Daniel | Principal Engineer</title>
        <meta name="description" content="David Daniel — Principal Engineer specializing in agentic engineering, AI transformations, cloud architecture, and scalable platform design." />
        <link rel="canonical" href="https://daviddaniel.tech/" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="David Daniel | Principal Engineer" />
        <meta property="og:description" content="David Daniel — Principal Engineer specializing in agentic engineering, AI transformations, cloud architecture, and scalable platform design." />
        <meta property="og:url" content="https://daviddaniel.tech/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="David Daniel" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="David Daniel | Principal Engineer" />
        <meta name="twitter:description" content="David Daniel — Principal Engineer specializing in agentic engineering, AI transformations, cloud architecture, and scalable platform design." />
      </Helmet>
      <div className="welcome-content">
        <header className="welcome-header">
          <h1 className="subtitle">David Daniel | Principal Engineer</h1>
        </header>

        <section className="welcome-description">
          <p>
            Principal Engineer specializing in agentic engineering, AI transformations,
            cloud architecture, and scalable platform design. This site hosts technical
            research on spec-driven development frameworks and agentic AI tools.
          </p>
        </section>

        <nav className="welcome-nav">
          <div className="nav-card">
            <h2>👤 About</h2>
            <p>
              Current professional bio — principal engineer and around-the-clock
              builder working in AI-native engineering, cloud architecture, and Proof Labs.
            </p>
            <Link to="/about/" className="nav-link">
              Read Bio →
            </Link>
          </div>

          <div className="nav-card">
            <h2>🔬 Technical Research</h2>
            <p>
              Spec-driven development frameworks, agentic AI tools, and research into
              methodologies like BMAD and SpecKit for scalable AI-native engineering.
            </p>
            <ul className="research-list">
              <li><a href="/research/papers/harness-engineering/">Harness Engineering</a></li>
              <li><a href="/research/papers/agentic-pricing-break/">When the Loop Never Stops</a></li>
              <li><a href="/research/papers/autonomous-agents/">Autonomous AI Agents</a></li>
              <li><a href="/research/papers/sdd-frameworks/">Spec-Driven Development Frameworks</a></li>
              <li><a href="/research/papers/agentic-tools/">Agentic Development Tools</a></li>
              <li><a href="/research/articles/specification-layer/">The Specification Layer</a></li>
            </ul>
            <a href="/research/" className="nav-link">
              Explore Research →
            </a>
          </div>

          <div className="nav-card secondary">
            <h2>📝 Early Portfolio (Archive)</h2>
            <p>
              Archived content from when I originally became a web developer. Work samples are no longer live.
            </p>
            <Link to="/bio/" className="nav-link">
              Visit Archive →
            </Link>
          </div>
        </nav>

        <footer className="welcome-footer">
          <p>&copy; 2026 David Daniel &middot; Principal Engineer</p>
          <div className="footer-links">
            <a href="https://linkedin.com/in/davidedaniel/" rel="me">LinkedIn</a>
            <a href="https://github.com/DavideDaniel" rel="me">GitHub</a>
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Welcome
